import { render } from "./AnalyticsNotesProductsTable.vue?vue&type=template&id=5bdfcf5f&scoped=true&ts=true"
import script from "./AnalyticsNotesProductsTable.vue?vue&type=script&lang=ts"
export * from "./AnalyticsNotesProductsTable.vue?vue&type=script&lang=ts"

import "./AnalyticsNotesProductsTable.vue?vue&type=style&index=0&id=5bdfcf5f&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bdfcf5f"]])

export default __exports__